import { z } from 'zod'

const apiEnvelope = <T extends z.ZodType>(data: T) =>
  z.object({
    data,
    errors: z.record(z.string(), z.array(z.string())).default({}),
    message: z.string().nullable().optional(),
    status: z.string(),
    meta: z.record(z.string(), z.unknown()).default({}),
  })

export const modelAuthRequestOtpResponse = apiEnvelope(
  z.object({
    result: z.string(),
    retryAfter: z.number(),
  }),
)

export const modelAuthLoginResponse = apiEnvelope(
  z.object({
    accessToken: z.string(),
    expiredAt: z.number(),
    refreshToken: z.string(),
    id: z.number().nullable(),
  }),
)

export type AuthTokens = z.infer<typeof modelAuthLoginResponse>['data']
